import type { FunctionComponent } from "react";
import { Field, FormTheme } from "@kanda-libs/ks-component-ts";
import { Text } from "@kanda-libs/ks-design-library";
import { getFinanceRateLabel, type FinanceRate } from "@kanda-libs/ks-frontend-services";

export interface RateRowProps {
  index: number;
  rate: FinanceRate;
}

const RateRow: FunctionComponent<RateRowProps> = function ({ index, rate }) {
  const apr = rate.apr_type === "INTEREST_FREE" ? 0 : (rate.apr || 0) / 100;

  return (
    <div className="flex flex-row items-center gap-x-3 border-b border-neutral-200 py-2">
      <FormTheme variant="inline">
        <div className="my-auto">
          <Field.BooleanInput name={`rates.${index}.selected`} handle="checkbox" />
        </div>
        <div className="flex flex-1 flex-col">
          <Text text={getFinanceRateLabel(rate)} className="text-14-22" />
          <Text
            text={`${apr}% APR · ${rate.duration || 0} months`}
            className="text-12-18 text-neutral-500"
          />
        </div>
        <div className="w-24">
          <Field.NumberInput
            type="price"
            name={`rates.${index}.fee`}
            suffix="%"
            symbol=""
            placeholder="0%"
          />
        </div>
      </FormTheme>
    </div>
  );
};

export default RateRow;
